import { requestJson } from './http';

export function getGuestBook(params = {}) {
  const query = new URLSearchParams(params);
  const qs = query.toString();
  return requestJson(`/api/guest-book${qs ? `?${qs}` : ''}`);
}
